import { getStoryQueryOptions } from '@/utils/fetchers/story'
import { useQuery } from '@tanstack/react-query'
import { useRef, useState } from 'react'
import StorySequence from './StorySequence'
import StoryViewerControls from './StoryViewerControls'
import StoryViewerFallback from './StoryViewerFallback'

export interface SingleStoryProps {
	storyId: string
	onClose: () => void
}

export default function SingleStory({ storyId, onClose }: SingleStoryProps) {
	const playbackTimesRef = useRef(new Map<string, number>())
	const readStoriesRef = useRef(new Set<string>())
	const [isMuted, setIsMuted] = useState(true)
	const storyQuery = useQuery(getStoryQueryOptions(storyId))

	if (!storyQuery.data) {
		return (
			<StoryViewerFallback
				status={storyQuery.isError ? 'error' : 'loading'}
				onClose={onClose}
				onRetry={storyQuery.isError ? () => void storyQuery.refetch() : undefined}
			/>
		)
	}

	return (
		<>
			<StorySequence
				active
				stories={[storyQuery.data]}
				initialStoryId={storyId}
				showStoryNavigation={false}
				playbackTimes={playbackTimesRef.current}
				readStories={readStoriesRef.current}
				isMuted={isMuted}
				onMutedChange={setIsMuted}
				onClose={onClose}
			/>
			<StoryViewerControls onClose={onClose} />
		</>
	)
}
